import React, { useState, useEffect, useRef } from "react";

const AnimatedNumber = ({ value, prefix = "", suffix = "", duration = 800 }) => {
  const [display, setDisplay] = useState(0);
  const prevRef = useRef(0);
  useEffect(() => {
    const start = prevRef.current;
    const end = typeof value === "number" ? value : parseFloat(value) || 0;
    if (start === end) { setDisplay(end); return; }
    const startTime = Date.now();
    const tick = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setDisplay(start + (end - start) * eased);
      if (progress < 1) requestAnimationFrame(tick);
      else prevRef.current = end;
    };
    requestAnimationFrame(tick);
  }, [value]);
  if (prefix === "$") return "$" + display.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return prefix + Math.round(display).toLocaleString() + suffix;
};

export default AnimatedNumber;
